export const commandsActions = {
    GET_COMMANDS: 'GET_COMMANDS',
    SET_COMMANDS: 'SET_COMMANDS',
    GET_COMMAND_PROPERTIES:'GET_COMMAND_PROPERTIES',
    SET_COMMAND_PROPERTIES:'SET_COMMAND_PROPERTIES',
    GET_GENERATE_SCRIPT:'GET_GENERATE_SCRIPT',
    SET_GENERATE_SCRIPT:'SET_GENERATE_SCRIPT'
};

const initState = {};

export const commandsReducer = (state = initState, action: any) => {
    switch (action.type) {
        case commandsActions.SET_COMMANDS:
        case commandsActions.SET_COMMAND_PROPERTIES:
        case commandsActions.SET_GENERATE_SCRIPT:
            return Object.assign({}, state, action.payload);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/commandsReducer.ts